export const DELETE_DASHBOARD_CONFIRMATION = 'Are you sure you want to delete this dashboard?';
export const PUBLISH_CONFIRMATION = 'Are you sure you want to publish the shifts?';
export const PUBLISH_SUCCESS = 'Successfully published shifts.';
export const OPTIMISE_CANCEL_CONFIRMATION = 'Are you sure you want to cancel the running optimisation?';
export const OPTIMISE_CONFIRMATION = 'This action will lock down everyone\'s ability to edit the data.';
export const OPTIMISE_PREPARE = 'Preparing for optimise';
export const OPTIMISE_PROGRESS = 'View optimise progress';
export const OPTIMISE_SUCCESS = 'Optimisation completed';
export const OPTIMISE_FAIL = 'Optimisation failed';
export const OPTIMISE_CANCELLED = 'Optimisation cancelled';
export const REPLAN_ACCEPT_CONFIRMATION = 'By accepting this result, the system will copy the shift to active plan. Proceed?';
export const REPLAN_REJECT_CONFIRMATION = 'By rejecting this result, the replan scenario will be removed permanently. Proceed?';
export const COPY_SHIFTS_SUCCESS = scenarioName => `Shifts from "${scenarioName}" successfully copied to active plan.`;
export const COPY_SHIFTS_FAILED = scenarioName => `Failed to copy shifts from "${scenarioName}" to active plan.`;

export const NO_SCENARIO_COMPARE_WHY1 = 'Please select only 2 scenarios with the same date.';
export const NO_SCENARIO_COMPARE_WHY2 = 'The 2 scenarios must have the same date.';
export const CAN_SCENARIO_COMPARE = 'Click to compare the 2 selected scenarios.';
export const DELETE_SCENARIO = scenarios => `Are you sure you want to delete these ${Object.keys(scenarios).length} scenarios? This action is irreversable.`;
export const REPLACE_PLAN = scenarioName => `You're about to make "${scenarioName}" the Active Plan. Do you wish to proceed?`;
export const DEPRECATED_DASHBOARD_FILTERS = 'Some old dashboard filters have been deprecated and no longer apply. Please re-apply the filters.';

export const SCENARIO_CREATE = scenarioName => `Successfully created a scenario - "${scenarioName}".`;
export const SCENARIO_UPDATE = scenarioName => `Successfully updated a scenario - "${scenarioName}".`;
export const SCENARIO_DELETE = scenarioName => `Successfully deleted a scenario - "${scenarioName}".`;

export const NO_DATA_FOUND = 'No data found.';
export const ADD_SUCCESS = type => `Added a new ${type}.`;
export const DELETE_SUCCESS = type => `${type} successfully removed.`;
export const EDIT_SUCCESS = type => `${type} successfully updated.`;
export const BULK_EDIT_SUCCESS = ({ ids, columns }) => `Edited ${ids.length} items. (Changed ${Object.keys(columns).join(', ')})`;
export const BULK_DELETE_DATA_CONFIRMATION = ids => `Are you sure you want to delete the selected ${Object.keys(ids).length} items?`;
export const BULK_DELETE_DATA_SUCCESS = ids => `${Object.keys(ids).length} items removed.`;
export const DOWNLOAD_HAPPENING = name => `${name} is currently downloading.`;
export const DOWNLOAD_FAILED = 'Download failed';
export const COPY_PREVIOUS_WEEK_SUCCESS = 'successfully copied previous week';
export const UPLOAD_SUCCESS = name => `${name} successfully uploaded.`;
export const UPLOAD_FAILURE = name => `Failed to upload ${name}.`;
export const UNLINK_CONFIRMATION = 'Are you sure? This action is irreversable and will NOT copy the data from active plan.';
export const UNLINK_AND_COPY_CONFIRMATION = 'Are you sure? This action is irreversable.';
export const LINKED_TEXT = 'Linked to Active Plan';
export const UNLINKED_TEXT = 'Not linked to Active Plan';
export const UNLINKED_NESTED_ROW = 'The previous selected row has been unlinked due to data change.';

export const IS_OPTIMISE = 'Data is not modifiable while optimising';
export const NOT_EDITABLE = 'Data is not editable.';
export const NOT_DELETABLE = 'Data is not deletable.';
export const COPY_DISABLED = 'Large datasets can not be copied to clipboard. Please use the file download instead';
export const NOT_ADDABLE = 'Cannot add to this data.';
export const NOT_BULK_EDITABLE = 'No data columns are bulk-editable.';
export const NO_ITEMS_SELECTED = 'There are no items selected.';
export const UPLOAD_NOT_AVAILABLE = 'Upload not available for this data.';
export const DATA_IS_LINKED = 'Current data is linked.';
export const DATA_EXISTS = 'There is already data in this dataset.';
export const IS_DUPLICATE = 'Cannot enter duplicate data.';
export const IS_NOT_FULL = 'All required fields must have a value';
export const IS_EMPTY = 'There must be at least one bulk edit operation.';
export const NO_EDITS = 'There are no edits to save.';
export const VOLUME_IS_LINKED = 'This volume is not unlinked with the active plan.';

export const DATES_OVERLAP = 'The selected historical date range overlaps with the scenario date range.';
export const DAY_MINIMUM = 'Must have at least one day selected.';

export const COPY_TO_CLIPBOARD = 'Data copied to clipboard for your pasting; convenience.';

export const IDLE = minutes => `The app has been inactive for awhile. Session expir
es in ${minutes} minute${(minutes > 1) ? 's' : ''}`;
export const LOG_OUT = 'Logging out...';

export const REPLAN_COMPARISON = 'Compare replan result';
